export function BrandMark(): React.JSX.Element {
  return (
    <div className="brand" aria-label="MendByte">
      <svg className="brand__mark" viewBox="0 0 40 40" aria-hidden="true">
        <path d="M9 5h10c10 0 16 6 16 15S29 35 19 35H9v-8h7V13H9z" />
        <path className="brand__join" d="M5 15h13M5 25h13" />
      </svg>
      <span>MendByte</span>
    </div>
  );
}
